import { render } from "./QuestionCardSelect.vue?vue&type=template&id=5805d701"
import script from "./QuestionCardSelect.vue?vue&type=script&lang=js"
export * from "./QuestionCardSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__